/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ailoaderstepgathering3Inputs */

const en_ailoaderstepgathering3 = /** @type {(inputs: Ailoaderstepgathering3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gathering the details`)
};

const de_ailoaderstepgathering3 = /** @type {(inputs: Ailoaderstepgathering3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details werden gesammelt`)
};

/**
* | output |
* | --- |
* | "Gathering the details" |
*
* @param {Ailoaderstepgathering3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ailoaderstepgathering3 = /** @type {((inputs?: Ailoaderstepgathering3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ailoaderstepgathering3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ailoaderstepgathering3(inputs)
	return de_ailoaderstepgathering3(inputs)
});
export { ailoaderstepgathering3 as "aiLoaderStepGathering" }